import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CreationStateService {
  private isInCreationModeSubject = new BehaviorSubject<boolean>(false);

  get isInCreationMode$(): Observable<boolean> {
    return this.isInCreationModeSubject.asObservable();
  }

  get isInCreationMode(): boolean {
    return this.isInCreationModeSubject.value;
  }

  setCreationMode(isCreating: boolean): void {
    this.isInCreationModeSubject.next(isCreating);
  }
}
